const theme = {
	light: {
		font: '#292F36',
		background: '#ffffff',
		footer: '#fbfbfb',
		links: '#305a42',
		links_hover: '#363636',
		scroll: '#16191E',
		JAVASCRIPT: '#f1e05a55',
		CSS: '#CEAFFF55',
		TYPESCRIPT: '#2b748955',
		SHELL: '#89e05155',
		PHP: '#8292D255',
		JAVA: '#b0721955',
		GERAL: '#36f10055',
		PRODUTIVIDADE: '#E2660055',
		GIT: '#5B7BD255',
		HTML: '#E2660055',
	},
	dark: {
		font: '#ffffff',
		background: '#15202B',
		footer: '#06111c',
		links: '#7bbf98',
		links_hover: '#AEFFD8',
		scroll: '#ffffff',
		JAVASCRIPT: '#CEBF0055',
		CSS: '#563d7c',
		TYPESCRIPT: '#2b748955',
		SHELL: '#89e05155',
		PHP: '#4F5D9555',
		JAVA: '#b0721955',
		GERAL: '#305a4255',
		PRODUTIVIDADE: '#E2660055',
		GIT: '#2A407B55',
		HTML: '#E2660055',
	},
};

export default theme;
